import { render, staticRenderFns } from "./v-header.vue?vue&type=template&id=6b391b7c&scoped=true"
import script from "./v-header.vue?vue&type=script&lang=js"
export * from "./v-header.vue?vue&type=script&lang=js"
import style0 from "./v-header.vue?vue&type=style&index=0&id=6b391b7c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b391b7c",
  null
  
)

export default component.exports